module.exports = __webpack_public_path__ + "static/media/48_tn.30d713f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/48_tn.jpg
// module id = 684
// module chunks = 0